import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { TransactionStatusDto } from './dtos/transaction-status.dto';

@Injectable({ providedIn: 'root' })
export class TransactionStatusApi {
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _httpClient = inject(HttpClient);

  private readonly _baseUrl = `${this._environmentConfig.pureSpectrum.url}/survey-transaction-status`;

  public list(): Observable<TransactionStatusDto[]> {
    return this._httpClient.get<TransactionStatusDto[]>(this._baseUrl);
  }
}
